import React, { FC, Fragment } from 'react';
import { Box, Typography } from '@mui/material';
import { User } from 'models/user';
import { Organization } from 'models/organization';
import { useTranslation } from 'react-i18next';

type NotificationOriginatorProps = {
    originator?: User | null;
};
const NotificationOriginator: FC<NotificationOriginatorProps> = ({ originator }: NotificationOriginatorProps) => {
    const { t: translate } = useTranslation(['notifications']);

    return (
        <Fragment>
            {originator ? (
                <Fragment>
                    <Box>{originator.fullName}</Box>
                    <Box>
                        <Typography variant="caption">{(originator.organization as Organization).name}</Typography>
                    </Box>
                </Fragment>
            ) : (
                // DD-3688: every notification has an originator; one that resolves to
                // nothing was caused through the public API, which has no user behind it.
                <Box>{translate('notifications:API_INTEGRATION')}</Box>
            )}
        </Fragment>
    );
};

export default NotificationOriginator;
